export enum RoutePaths {
    AuthVerify = '/auth/verify',
    Home = '',
    ChartReader = '/chart-reader',
}

export enum PageNames {
    AuthVerify = 'Auth Verification',
    Home = 'Home',
    ChartReader = 'Chart Reader',
}

export const PageNamesToRoutePaths: Record<PageNames, RoutePaths> = {
    [PageNames.AuthVerify]: RoutePaths.AuthVerify,
    [PageNames.Home]: RoutePaths.Home,
    [PageNames.ChartReader]: RoutePaths.ChartReader,
};